/**
 * Each PromptType is associated with a incremented value corresponding to its priority, starting from 1.
 * The lower the value, the higher the priority of the PromptType.
 */
export enum PromptType {
  PRAYER = 1, // 1,
  MAIL_DELIVERY_ISSUE, // 2
  LINUX, // 4
  COMMUNITIES_PROPOSITIONS, // ...
  PUSH_REQUEST,
  INSTALL_APP,
  RATE_APP,
}
